(function($) {

    $(document).on('click', '.btn-show-drawer', function() {
        let target = $($(this).data('target'));

        target.trigger('drawerShow');

        target.addClass('show');
        $('.drawer-backdrop').addClass('show');
        $('body').css('overflow', 'hidden');

        setTimeout(function() {
            target.trigger('drawerShown');
        }, 400);
    });

    $(document).on('click', '.drawer .drawer-close', function() {
        let drawer = $(this).closest('.drawer');

        drawer.trigger('drawerClose');

        drawer.removeClass('show');
        $('.drawer-backdrop').removeClass('show');
        $('body').css('overflow', 'visible');

        setTimeout(function() {
            drawer.trigger('drawerClosed');
        }, 400);
    });

})(jQuery);